import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { useSelector } from 'react-redux';

import { useStylesModalOffer } from './hooks/useStyles';
import { useGetProduct } from './hooks/useGetProduct';
import Preloader from '../../../../../components/other/Preloader/Preloader';
import { Header } from './Header';
import { Offer, OfferMethods } from './Offer';
import { useDefineUserRole } from '../../../../../hooks';
import { IAppState } from '../../../../../store/rootDuck';
import { OffersForBuyer } from './OffersForBuyer';

export function ProductOffer({
  id,
  closeModal,
}: {
  id?: number | null;
  closeModal: () => void;
}) {
  const isAuthorized = useSelector((state: IAppState) => state.auth.user != null);
  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));
  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER', 'ROLE_BUYER_STAFF']);
  const { classes } = useStylesModalOffer();
  const offerRef = useRef<OfferMethods>(null);
  const { fetchProduct, product, loading } = useGetProduct();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(!!id);
    if (id) fetchProduct(id);
  }, [id]);

  if (!id) return null;

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          background: 'transparent',
          boxShadow: 'none',
          width: '100%',
          maxHeight: isBuyer || !isAuthorized ? '100%' : undefined,
        },
      }}
      open={showModal}
      onClose={closeModal}
      maxWidth='xl'
      slotProps={{
        backdrop: {
          style: {
            backdropFilter: 'blur(3px)',
            backgroundColor: 'rgba(0,0,30,0.4)',
          },
        },
      }}
    >
      <DialogContent className={classes.dialogContent}>
        {loading || !product ? (
          <Preloader />
        ) : (
          <>
            <Header product={product} closeModal={closeModal} />
            {isBuyer || !isAuthorized ? (
              <OffersForBuyer product={product} />
            ) : (
              <div className={classes.containerModalOffers}>
                {me?.is_admin && (
                  <OffersForBuyer
                    product={product}
                    setCompany={company => {
                      offerRef.current?.setCompany(company);
                    }}
                  />
                )}
                <Offer id={id} offerRef={offerRef} />
              </div>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
